import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TrackingnumberComponent } from './trackingnumber.component';

const routes: Routes = [
  { path: '', component: TrackingnumberComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TrackingnumberRoutingModule { }
